import { render, staticRenderFns } from "./AdminWorkspacePopup.vue?vue&type=template&id=77bc380f&scoped=true&"
import script from "./AdminWorkspacePopup.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspacePopup.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkspacePopup.vue?vue&type=style&index=0&id=77bc380f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc380f",
  null
  
)

export default component.exports